import * as h2Api from '../h2Api'

export const LOOKUP_MGMT_CODE = 'MINI_HUB_LOOKUP_MGMT_CODE'
export const LOAD_MINI_HUB = 'LOAD_MINI_HUB'
export const RESET_MGMT_CODE_LOOKUP = 'RESET_MGMT_CODE_LOOKUP'
export const SET_RELOAD_FLAG = 'HUB_SET_RELOAD_FLAG'
export const ACKNOWLEDGE_MINIHUB_TUTORIAL = 'ACKNOWLEDGE_MINIHUB_TUTORIAL'

export const lookupUserByCode = code => dispatch => {
  return dispatch(
    h2Api.post('/management/finduser', {
      user: code
    })({ type: LOOKUP_MGMT_CODE })
  )
}

export const acknowledgeHomeTutorial = isAcknowledged => dispatch => {
  return dispatch({ type: ACKNOWLEDGE_MINIHUB_TUTORIAL, isAcknowledged })
}

export const resetCode = () => dispatch => {
  return Promise.resolve(dispatch({ type: RESET_MGMT_CODE_LOOKUP }))
}

export const setReloadFlag = (newState = true) => dispatch => {
  return dispatch({ type: SET_RELOAD_FLAG, newState })
}

export const loadHubData = () => dispatch => {
  return dispatch(h2Api.get('/user/minihub')({ type: LOAD_MINI_HUB }))
}
